import { defineMessages } from 'react-intl';

/** Every copy of the grouping UI. `family` values: 'screens' | 'locations' | 'venues'. */
export const groupingMessages = defineMessages({
  add: { defaultMessage: 'Add', id: 'common.add' },
  addItems: {
    defaultMessage: '{family, select, screens {Add Screens} locations {Add Areas} other {Add POIs}}',
    id: 'groupItemsModal.addFamilyItems'
  },
  addItemsHint: {
    defaultMessage: 'Select and click “Add” to include it in the group.',
    id: 'groupItemsModal.addItemsHint'
  },
  addItemsPlaceholder: {
    defaultMessage: '{family, select, screens {Select Screens} locations {Select Areas} other {Select POIs}}',
    id: 'groupItemsModal.addItemsPlaceholder'
  },
  addToGroup: { defaultMessage: 'Add to group', id: 'groupItemsModal.addToGroup' },
  cancel: { defaultMessage: 'Cancel', id: 'common.cancel' },
  cartographyCreateError: {
    defaultMessage: 'The cartographic groups could not be created. Please try again.',
    id: 'groupItemsModal.cartographyCreateError'
  },
  cartographyLevel: { defaultMessage: 'Level', id: 'groupItemsModal.cartographyLevel' },
  cartographyLevelLoading: { defaultMessage: 'Loading levels…', id: 'groupItemsModal.cartographyLevelLoading' },
  cartographyLoadError: {
    defaultMessage: 'The cartographic levels could not be loaded. Please try again.',
    id: 'groupItemsModal.cartographyLoadError'
  },
  confirm: { defaultMessage: 'Confirm', id: 'common.confirm' },
  deleteGroup: { defaultMessage: 'Delete group', id: 'groupItemsModal.deleteGroup' },
  deleteGroupWarning: {
    defaultMessage: 'This group will be deleted when you save changes.',
    id: 'groupItemsModal.deleteGroupWarning'
  },
  deleteMembers: { defaultMessage: 'Delete', id: 'common.delete' },
  deletePromptDescription: {
    defaultMessage:
      'It is used by {ads, plural, one {# ad} other {# ads}} and {temporalPacing, plural, one {# temporal pacing configuration} other {# temporal pacing configurations}}. Deleting it will also remove it from them.',
    id: 'groupItemsModal.deletePrompt.description'
  },
  deletePromptTitle: {
    defaultMessage: 'Delete group “{name}”?',
    id: 'groupItemsModal.deletePrompt.title'
  },
  editGroup: { defaultMessage: 'Edit group', id: 'groupItemsModal.editGroup' },
  editGroupNamed: { defaultMessage: 'Edit group {name}', id: 'groupItemsModal.editGroupNamed' },
  editGroupsDescription: {
    defaultMessage: 'Choose the group you wish to edit',
    id: 'groupItemsModal.editGroupsDescription'
  },
  editGroupsTitle: { defaultMessage: 'Edit Groups', id: 'groupItemsModal.editGroupsTitle' },
  emptyGroupWarning: {
    defaultMessage: 'This group has no items left and will be deleted when you save changes.',
    id: 'groupItemsModal.emptyGroupWarning'
  },
  existingGroupsTitle: { defaultMessage: 'Existing groups', id: 'groupItemsModal.existingGroupsTitle' },
  familyItemsCount: {
    defaultMessage:
      '{count, plural, one {# {family, select, screens {Screen} locations {Area} other {POI}}} other {# {family, select, screens {Screens} locations {Areas} other {POIs}}}}',
    id: 'groupItemsModal.familyItemsCount'
  },
  groupColor: { defaultMessage: 'Group color', id: 'groupItemsModal.groupColor' },
  groupName: { defaultMessage: 'Group name', id: 'groupItemsModal.groupName' },
  groupNameExists: {
    defaultMessage: 'A group with the same name already exists',
    id: 'groupItemsModal.groupNameExists'
  },
  groupNamePlaceholder: {
    defaultMessage: 'Type a name for your group',
    id: 'groupItemsModal.groupNameInputPlaceholder'
  },
  groupingMode: { defaultMessage: 'Grouping mode', id: 'groupItemsModal.groupingMode' },
  groupingModeCartography: { defaultMessage: 'Cartographic', id: 'groupItemsModal.groupingMode.cartography' },
  groupingModeCustom: { defaultMessage: 'Custom', id: 'groupItemsModal.groupingMode.custom' },
  groups: { defaultMessage: 'Groups', id: 'groupItemsModal.groups' },
  keepGroup: { defaultMessage: 'Keep group', id: 'groupItemsModal.keepGroup' },
  newGroupTitle: { defaultMessage: 'New group', id: 'groupItemsModal.newGroupTitle' },
  noItemsToAdd: {
    defaultMessage:
      '{family, select, screens {No Screens available} locations {No Areas available} other {No POIs available}}',
    id: 'groupItemsModal.noItemsToAdd'
  },
  notificationAdded: {
    defaultMessage: '{items} added to “{name}”',
    id: 'groupItemsModal.notification.added'
  },
  notificationCartography: {
    defaultMessage: '{created, plural, one {# group} other {# groups}} created, {updated} updated.',
    id: 'groupItemsModal.notification.cartography'
  },
  notificationCartographyExcluded: {
    defaultMessage: '{items} had no area at this level.',
    id: 'groupItemsModal.notification.cartographyExcluded'
  },
  notificationCreated: {
    defaultMessage: 'Group “{name}” created with {items}',
    id: 'groupItemsModal.notification.created'
  },
  notificationDeleted: {
    defaultMessage: 'Group “{name}” deleted',
    id: 'groupItemsModal.notification.deleted'
  },
  notificationUpdated: {
    defaultMessage: 'Group “{name}” updated',
    id: 'groupItemsModal.notification.updated'
  },
  removeMember: { defaultMessage: 'Remove {name} from the group', id: 'groupItemsModal.removeMember' },
  saveChanges: { defaultMessage: 'Save changes', id: 'groupItemsModal.saveChanges' },
  selectPlaceholder: { defaultMessage: 'Select...', id: 'groupItemsModal.selectPlaceholder' },
  selectedForGrouping: {
    defaultMessage: '<bold>{items}</bold> selected for grouping:',
    id: 'groupItemsModal.selectedItemsForGrouping'
  },
  showGroups: { defaultMessage: 'Show groups', id: 'groupItemsModal.showGroups' }
});
